<template>
    <div class="document-log v-scrollable">   
      <h1>Uppsala vatten</h1>
      <br>
      <button @click="loadStatus()">Update status</button> &nbsp;<button @click="start()">Start</button>
      <br><br>
      <h2>Status</h2>
      <br>
      <div>{{ status.status }}</div>
      <br>
      <h2>Description</h2>
      <br>
      <pre>{{status.description}}</pre>
      <br>
      <h2>Messages</h2>
      <br>
      <pre>{{status.error}}</pre>
    </div>
  </template>
  
  
  <script>
  
  import $ from 'jquery'
  import { mapGetters, mapActions, mapSetters, mapState } from 'vuex'
  
  
  export default { 
      name: 'uppsala-vatten',
      components: {
  
      },
      data(){
        return {
          message: ''
        }
      },
      mounted(){
        this.loadStatus();
      },
      computed: {
        status () {
            return this.$store.state.uppsalaVatten
        },
        
      },
      methods: {
        loadStatus () {
            this.$store.dispatch('loadUppsalaVatten')
        },
        start (){
            this.$store.dispatch('startUppsalaVatten')
        }
    
      }
    }
  
  </script>
  
  
  <style scoped>
  
  input{
    width: 100%;
  }
  
  </style>
  